import { getPianoAccount } from '@/app_actions/Piano/pianoAccountActions';
import type { Tinypass } from '@/app_lib/types/tinypass';

export const checkPianoAccountExists = async (email: string, tp: Tinypass) => {
  const loggedInUser = tp.pianoId.getUser();
  if (loggedInUser) {
    return { hasAccount: true, userId: loggedInUser.uid };
  }

  try {
    const user = await getPianoAccount(email);
    if (user !== null) {
      return { hasAccount: true, userId: user.uid };
    }
    return { hasAccount: false };
  } catch (_error) {
    return { hasAccount: false };
  }
};

export const getLts = (tp: Tinypass, experienceId: string, eventType: string): string => {
  const experienceResult = tp.experience._getLastExecutionResult();
  const userSegments = experienceResult.result?.events.find(
    (event) => event.eventType === eventType && event.eventExecutionContext.experienceId === experienceId,
  )?.eventExecutionContext.userSegments;
  const lts = userSegments?.COMPOSER1X
    ? userSegments?.COMPOSER1X.segments.find((score) => score.startsWith('LTs'))
    : 'no_score';

  return lts || 'no_score';
};
